module.exports = __webpack_public_path__ + "img/20191210162025360截图20191210160536791.1c7099dc.jpg";